import videojs from "video.js";
import "video.js/dist/video-js.css";
import styled from "./PlayerMain.module.scss";

type VJPlayer = ReturnType<typeof videojs>;
const Component = videojs.getComponent("Component");

class VjsDualVolume extends Component {
    private vjPlayer: VJPlayer;
    private audioRef: React.RefObject<HTMLAudioElement>;
    private videoRef: React.RefObject<HTMLVideoElement>;

    constructor(player: VJPlayer, options: any) {
        super(player, options);
        this.vjPlayer = player;
        this.audioRef = options.audioRef;
        this.videoRef = options.videoRef;

        this.el().classList.add(styled["vjs-dual-volume"]);

        // Иконка громкости
        const button = videojs.dom.createEl("button", {
            className: `vjs-control vjs-button ${styled["vjs-volume-icon"]} ${styled.audioIcon}`,
        }) as HTMLButtonElement;
        button.onmouseenter = () => {
            this.el().classList.toggle(styled["open"]);
        };
        button.onmouseleave = () => {
            this.el().classList.toggle(styled["open"]);
        };

        // Слайдеры
        const slidersContainer = videojs.dom.createEl("div", {
            className: `${styled["volume-sliders"]}`,
        });

        slidersContainer.addEventListener("mouseleave", () => {
            this.el().classList.toggle(styled["open"]);
        });

        // Слайдер видео
        const videoSlider = this.createSlider(
            this.vjPlayer.volume() ?? 1,
            (val) => {
                if (this.videoRef) {
                    this.videoRef.current.volume = val;
                }
            },
        );

        // Слайдер аудио
        const audioSlider = this.createSlider(
            this.audioRef.current?.volume ?? 1,
            (val) => {
                if (this.audioRef.current) {
                    this.audioRef.current.volume = val;
                }
            },
        );

        audioSlider.oninput = () => {
            if (this.audioRef.current) {
                this.audioRef.current.volume = parseFloat(audioSlider.value);
            }
        };

        slidersContainer.appendChild(videoSlider);
        slidersContainer.appendChild(audioSlider);

        this.el().appendChild(button);
        this.el().appendChild(slidersContainer);
    }

    private createSlider(
        initialValue: number,
        onChange: (val: number) => void,
    ) {
        const slider = document.createElement("input");
        slider.type = "range";
        slider.min = "0";
        slider.max = "1";
        slider.step = "0.01";
        slider.value = String(initialValue);
        slider.className = styled["range"]; // или просто "range" если не модули

        // Устанавливаем CSS-переменную сразу (важно)
        slider.style.setProperty("--percent", `${initialValue * 100}%`);

        slider.addEventListener("input", (e) => {
            const val = parseFloat((e.target as HTMLInputElement).value);
            // обновляем css-переменную
            slider.style.setProperty("--percent", `${val * 100}%`);
            onChange(val);
        });

        return slider;
    }

    createEl() {
        return videojs.dom.createEl("div", {
            className: `vjs-control ${styled["vjs-dual-volume"]}`,
        });
    }
}

videojs.registerComponent("VjsDualVolume", VjsDualVolume);

export default VjsDualVolume;
